module.exports = __webpack_public_path__ + "static/media/s29.de686aef.jpg";